import { pr } from '@/utils/pxToRem';
import { Box } from '@mui/system';
import React from 'react';

// Component
import FareInWeek from './FareInWeek';

function SectionCheckPrice(props: any) {
  const {
    days, onSearchFlight, isDesktop,
  } = props;

  return (
    <Box sx={{
      background: '#FFFFFF',
      boxShadow: '0px 2px 10px rgba(7, 65, 57, 0.15)',
      borderRadius: '12px',
      overflow: 'hidden',
      mt: pr`8px`,
    }}
    >
      <FareInWeek
        isDesktop={isDesktop}
        days={days}
        onSearchFlight={onSearchFlight}
      />
    </Box>
  );
}

export default React.memo(SectionCheckPrice);
